import { LG_BREAKPOINT } from '@src/constants/breakpoints';
import {
  DESKTOP_HEADER_SCROLL_OFFSET,
  FOOTER_SCROLL_TO_ID,
  MOBILE_HEADER_SCROLL_OFFSET
} from '@src/constants/site';
import { NextRouter } from 'next/router';

export const handleEnquireButtonScrollToClick = (
  width: number,
  router?: NextRouter,
  event?: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  handleCloseMobileMenu?: ((event: React.MouseEvent) => void) | undefined,
  scrollToId?: string,
  isTourBooking: boolean = false
) => {
  requestAnimationFrame(() => {
    if (handleCloseMobileMenu && event) {
      handleCloseMobileMenu(event);
    }

    // ensure hash param is cleared so the form re-renders
    if (router) {
      if (router.asPath.includes('#')) {
        const currentRouteWithoutHashParam = router.asPath.split('#')[0];
        router.push(currentRouteWithoutHashParam);
      }
    }

    // target DOM node to scroll to
    const scrollElement = document.getElementById(
      scrollToId ? scrollToId : FOOTER_SCROLL_TO_ID
    );
    const headerOffset =
      width < LG_BREAKPOINT
        ? MOBILE_HEADER_SCROLL_OFFSET
        : DESKTOP_HEADER_SCROLL_OFFSET;
    const elementPosition = scrollElement?.getBoundingClientRect().top;
    const offsetPosition =
      (elementPosition || 0) + window.scrollY - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });

    const form = document.querySelector('#footerEnquireForm');
    if (form) {
      const bookVisitCheckbox = form.querySelector(
        'input[name="bookVisit"]'
      ) as HTMLInputElement;
      if (bookVisitCheckbox) {
        bookVisitCheckbox.checked = isTourBooking;
      }
    }
  });
};
